import axios from 'axios'

export default {
    fetchSoftDown(params) {
        return axios.get('/cltDown_listAll.do',{ params})
    }
}